// Home-screen status strip (BUILD_SPEC.md §11): silo levels, open POs, uninvoiced
// dispatches, low stock count. Hits the reporting module's `GET /reporting/site-status`
// endpoint; SiteStatusStrip renders skeleton tiles while loading/on error, real numbers
// otherwise.
import { useApiQuery } from './useApi';

export interface SiloStatus {
  siloId: string;
  name: string;
  estimatedPct: number | null;
}

export interface SiteStatus {
  openPurchaseOrders: number;
  uninvoicedDispatches: number;
  lowStockCount: number;
  silos: SiloStatus[];
}

export function useSiteStatus() {
  return useApiQuery<SiteStatus>(['reporting', 'site-status'], '/reporting/site-status', {
    // Dashboard garnish, not workflow data — on failure show skeletons quietly
    // rather than retry-hammering the API.
    retry: false,
  });
}
